module.exports = __webpack_public_path__ + "img/referrals.83285f4d.svg";